import { useLastUpdate } from "@/hooks/useLastUpdate";
import { Skeleton } from "@/components/ui/skeleton";
import { Clock } from "lucide-react";

interface LastUpdateInfoProps {
  tableName: string;
  entityType?: string;
}

export function LastUpdateInfo({ tableName, entityType }: LastUpdateInfoProps) {
  const { data: lastUpdate, isLoading } = useLastUpdate({ tableName, entityType });

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Clock className="h-4 w-4" />
        <Skeleton className="h-4 w-64" />
      </div>
    );
  }

  if (!lastUpdate) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Clock className="h-4 w-4" />
        <span>Nenhuma atualização registrada</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <Clock className="h-4 w-4" />
      <span>
        Última atualização: {lastUpdate.date} • {lastUpdate.userName}
      </span>
    </div>
  );
}
